<template>
	<div class="login_container">
		<a href="http://www.rdxfpx119.com/" class="back_index_btn">返回首页</a>
		<div class="login_con">
			<div class="login_types">
				<!-- <div class="login_type" @click="typeChange('code')">
					<div class="type_word">微信登录</div>
					<div v-if="loginType == 'code'" class="type_line"></div>
				</div> -->
				<div class="login_type" @click="typeChange('user')">
					<div class="type_word">账号登录</div>
					<!-- <div v-if="loginType == 'user'" class="type_line"></div> -->
				</div>
			</div>
			<div v-if="loginType == 'code'" class="login_code" id="login_code">
				<div class="code_pic">
					<!-- <img src="../assets/images/code_pic.png" alt=""/> -->
					<wxlogin :appid="appId" :scope="scope" :redirect_uri="redirectUrl" :href="cssHref"></wxlogin> 
				</div>
				<div class="code_word">微信扫码，安全登录</div>
			</div>
			<div v-if="loginType == 'user'" class="login_user">
				<div class="user_input">
					<div class="input_icon">
						<img src="../assets/images/icon_user.png" alt=""/>
					</div>
					<input v-model="loginData.phone" type="text" maxlength="11" placeholder="请输入账号" placeholder-style="color:#9c9c9c"/>
				</div>
				<div class="user_input">
					<div class="input_icon">
						<img src="../assets/images/icon_password.png" alt=""/>
					</div>
					<input v-model="loginData.password" type="password" placeholder="请输入密码" placeholder-style="color:#9c9c9c"/>
				</div>
				<div class="forget_btn">
					<!-- <router-link class="forget_btn_text" :to="{path:'forget'}">忘记密码</router-link> -->
				</div>
				<div class="login_now">
					<!-- <div class="login_text">还没有账号？立即<router-link :to="{path:'register'}">注册</router-link></div> -->
					<div @click="loginForm" class="login_btn">登录</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import wxlogin from 'vue-wxlogin';
	import { getToken } from '@/api/login.js'
	import { loginFun } from '@/api/login.js'
	import { wxloginFun } from '@/api/login.js'
	export default {
		name: 'login',
		components: {
			wxlogin
		},
		data () {
			return {
				loginType: 'user',
				tokenRequestData:{
					access_key: '5b103d9af77e062b8433bb430308060d',
					who: 0
				},
				loginData:{
					phone: '',
					password: '',
					token: ''
				},
				timer: null,
				appId: 'wxc259408937ae0090',
				scope: 'snsapi_login',
				redirectUrl: encodeURIComponent('http://dt.rdxfpx119.com/dist/index.html#/'),
				cssHref: 'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKICAgIGRpc3BsYXk6IG5vbmU7Cn0KCi5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgewogICAgZGlzcGxheTogbm9uZTsKfQoKLmltcG93ZXJCb3ggLnFyY29kZSB7CiAgICBib3JkZXI6IG5vbmU7CiAgICB3aWR0aDogMjM2cHg7CiAgICBoZWlnaHQ6IDIzNnB4OwogICAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZmZmZjsKICAgIG1hcmdpbjogMDsKfQoKLmltcG93ZXJCb3ggLmluZm8gewogICAgZGlzcGxheTogbm9uZQp9'
			}
		},
		computed: {
			
		},
		created () {
			
		},
		mounted () {
			this.getTokenFun();
			this.setIntervalFun();
		},
		methods: {
			//获取token
			getTokenFun(){
				let that = this;
				let data = this.tokenRequestData;
				getToken(data).then(res =>{
					if(res.code == 0){
						localStorage.setItem("token", res.data.token);
						that.loginData.token = res.data.token;
					}
				})
			},
			//扫码登录成功
			setIntervalFun(){
				let that = this;
				let data = {
					code: ''
				}
				that.timer = setInterval(function(){
					if(window.location.href.substr(1).split("&")[0].split("=")[1]){
						window.clearInterval(that.timer);
						let code = window.location.href.substr(1).split("&")[0].split("=")[1];
						data.code = code;
						wxloginFun(data).then(res =>{
							if(res.code == 0){
								window.clearInterval(that.timer);
								that.$message.success("登录成功");
								localStorage.setItem("userInfo", JSON.stringify(res.data.user));
								setTimeout(function(){
									that.$router.replace({ path: "/home" });
								},1000)
							}else{
								that.$message.error(res.message);
							}
						})

					}
				},1000)
			},
			typeChange(type){
				this.loginType = type;
			},
			loginForm(){
				let that = this;
				// let phone_num = this.loginData.phone;
				if(this.loginData.phone == ''){
					this.$message.error('请输入账号！');
					return
				}
				if(this.loginData.password == ''){
					this.$message.error('请输入密码！');
					return
				}
				let data = this.loginData;
				loginFun(data).then(res =>{
					if(res.code == 0){
						window.clearInterval(that.timer);
						that.$message.success("登录成功");
						localStorage.setItem("userInfo", JSON.stringify(res.data.user));
						that.$router.replace({ path: "/home" });
					}else{
						that.$message.error(res.message);
					}
				})
			},
			//校验手机号
			checkPhone(phone){ 
				if(!(/^1[3456789]\d{9}$/.test(phone))){ 
					this.$message.error("请填写正确的手机号!");  
					return false; 
				} else{
					return true
				}
			}
        }
	}
</script>

<style>
	.login_container{
        width: 100%;
        height: 100%;
		position: relative;
		background-image: url('../assets/images/bg.jpg');
		background-size: 100% 100%;
		z-index: 10;
    }
	.back_index_btn{
		font-size: 18px;
		color: #000000;
		position: absolute;
		right: 50px;
		top: 72px;
		border-bottom: 1px solid #000000;
	}
	.login_con{
		width: 488px;
		height: 540px;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -270px;
		margin-left: -244px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		background-image: url('../assets/images/login_bg.png');
		background-size: 100% 100%;
	}
	.login_types{
		width: 296px;
		height: 35px;
		margin-top: 68px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center
	}
	.login_types .login_type{
		height: 35px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}
	.login_types .login_type .type_word{
		width: 80px;
		height: 34px;
		line-height: 34px;
		font-size: 18px;
		color: #313330;
	}
	.login_types .login_type .type_line{
		width: 80px;
		height: 1px;
		background-color: #000000;
	}
	.login_code{
		width: 236px;
		height: 280px;
		margin-top: 50px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
	}
	.login_code .code_pic{
		width: 236px;
		height: 236px;
		background-color: #ffffff;
	}
	.login_code .code_word{
		width: 236px;
		height: 24px;
		margin-top: 12px;
		line-height: 24px;
		color: #525252;
		font-size: 16px;
	}
	.login_user{
		width: 365px;
		height: 282px;
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
	}
	.login_user .user_input{
		width: 365px;
		height: 52px;
		background-color: #ffffff;
		margin-top: 30px;
		border-radius: 52px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start
	}
	.login_user .user_input .input_icon{
		width: 20px;
		height: 24px;
		margin-left: 20px;
		margin-right: 38px
	}
	.login_user .user_input input{
		width: 260px;
		height: 24px;
		font-size: 14px;
		color: #333333;
		background: rgba(0,0,0,0);
		background:none;  
		outline:none;  
		border:none;
	}
	.login_user .user_input input:focus{  
		border:none;
	}
	.login_user .forget_btn{
		width: 365px;
		height: 26px;
		margin-top: 15px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		margin-bottom: 28px;
	}
	.login_user .forget_btn .forget_btn_text{
		width: 65px;
		height: 26px;
		line-height: 26px;
		text-align: right;
		font-size: 12px;
		color: #9a9899;
		cursor: pointer;
	}
	.login_user .login_now{
		width: 365px;
		height: 48px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between
	}
	.login_user .login_now .login_text{
		font-size: 12px;
		color: #9a9899;
	}
	.login_user .login_now .login_text a{
		font-size: 16px;
		color: #fe0100;
		cursor: pointer;
		margin-left: 2px;
	}
	.login_user .login_now .login_btn{
		width: 365px;
		height: 48px;
		background-color: #fe0100;
		border-radius: 48px;
		line-height: 48px;
		text-align: center;
		color: #ffffff;
		cursor: pointer;
	}
</style>
